import type { CSSProperties } from 'react';
import { TableSortLabel } from '@material-ui/core';
import { TableCell } from '../styled';
import { SortIcon, ArrowIcon } from 'components/icons';
import { Truncate } from 'components/styled-components';

import { useStyles } from './style';

interface ActionSortTableCellProps {
  active: boolean;
  disabled?: boolean;
  order?: 'asc' | 'desc';
  onChangeSortParams?: () => void;
  style?: CSSProperties;
}

const ActiveIcon = (props: { order?: 'asc' | 'desc' }) => {
  const { order } = props;

  return (
    <ArrowIcon
      dir={order === 'asc' ? 'top' : 'bottom'}
      style={{ marginLeft: 7 }}
    />
  );
};

const ActionSortTableCell: React.FC<ActionSortTableCellProps> = (props) => {
  const classes = useStyles();

  const { active, order, disabled, onChangeSortParams, children, style } =
    props;

  return (
    <TableCell className={classes.cell} style={style}>
      <TableSortLabel
        active={active}
        classes={{
          root: classes.tableSortRoot,
          icon: classes.visible,
        }}
        direction={active ? order : 'asc'}
        disabled={disabled}
        hideSortIcon={disabled}
        onClick={onChangeSortParams}
        IconComponent={(params) => {
          return active ? (
            <ActiveIcon order={order} />
          ) : (
            <SortIcon {...params} style={{ marginLeft: 7 }} />
          );
        }}
      >
        <Truncate title={typeof children === 'string' ? children : undefined}>
          {children}
        </Truncate>
      </TableSortLabel>
    </TableCell>
  );
};

export default ActionSortTableCell;
